import {createSlice} from "@reduxjs/toolkit";
import {
    getConversionRate,
    getConversionsByInfluencer,
    getConversionsBySocialMedia,
    getConversionsBySubcategory
} from "./conversion.thunk.js";
import { resetAnalyticsOnSectionChange } from "../appNavigation.actions.js";

const initialState = {
    conversionsStatsData: {
        conversionsRate: 0,
        subCateg: {
            chartData: {
                labels: [],
                datasets: {data: []}
            },
            tableData: [],
            totalRows: 0,
        },
        influencer: {
            chartData: {
                labels: [],
                datasets: {data: []}
            },
            tableData: [],
            totalRows: 0,
        },
        socialMedia: {
            chartData: {
                labels: [],
                datasets: {data: []}
            },
            tableData: [],
            totalRows: 0,
        }
    },
    getConversionRateStatus: 'idle',
    getConversionsByInfluencerStatus: 'idle',
    getConversionsBySubcategoryStatus: 'idle',
    getConversionsBySocialMediaStatus: 'idle',
    errors: {}
};

export const conversionSlice = createSlice({
    name: "conversion",
    initialState,
    extraReducers(builder) {
        builder
            .addCase(getConversionRate.pending, (state) => {
                state.getConversionRateStatus = 'loading';
            })
            .addCase(getConversionRate.fulfilled, (state, action) => {
                delete state.errors.rate;
                state.conversionsStatsData = {...state.conversionsStatsData, ...action.payload};
                state.getConversionRateStatus = 'succeeded';
            })
            .addCase(getConversionRate.rejected, (state, action) => {
                state.errors = {...state.errors, rate: action.payload};
                state.getConversionRateStatus = 'failed';
            })
            .addCase(getConversionsByInfluencer.pending, (state) => {
                state.getConversionsByInfluencerStatus = 'loading';
            })
            .addCase(getConversionsByInfluencer.fulfilled, (state, action) => {
                delete state.errors.influencer;
                state.conversionsStatsData = {...state.conversionsStatsData, ...action.payload};
                state.getConversionsByInfluencerStatus = 'succeeded';
            })
            .addCase(getConversionsByInfluencer.rejected, (state, action) => {
                state.errors = {...state.errors, influencer: action.payload};
                state.getConversionsByInfluencerStatus = 'failed';
            })
            .addCase(getConversionsBySubcategory.pending, (state) => {
                state.getConversionsBySubcategoryStatus = 'loading';
            })
            .addCase(getConversionsBySubcategory.fulfilled, (state, action) => {
                delete state.errors.subcategory;
                state.conversionsStatsData = {...state.conversionsStatsData, ...action.payload};
                state.getConversionsBySubcategoryStatus = 'succeeded';
            })
            .addCase(getConversionsBySubcategory.rejected, (state, action) => {
                state.errors = {...state.errors, subcategory: action.payload};
                state.getConversionsBySubcategoryStatus = 'failed';
            })
            .addCase(getConversionsBySocialMedia.pending, (state) => {
                state.getConversionsBySocialMediaStatus = 'loading';
            })
            .addCase(getConversionsBySocialMedia.fulfilled, (state, action) => {
                delete state.errors.socialMedia;
                state.conversionsStatsData = {...state.conversionsStatsData, ...action.payload};
                state.getConversionsBySocialMediaStatus = 'succeeded';
            })
            .addCase(getConversionsBySocialMedia.rejected, (state, action) => {
                state.errors = {...state.errors, socialMedia: action.payload};
                state.getConversionsBySocialMediaStatus = 'failed';
            })
            .addCase(resetAnalyticsOnSectionChange, () => JSON.parse(JSON.stringify(initialState)));
    }
});

export const selectConversionsStatsData = (state) => state.conversion.conversionsStatsData;

export const selectConversionRateStatus = (state) => state.conversion.getConversionRateStatus;
export const selectConversionsByInfluencerStatus = (state) => state.conversion.getConversionsByInfluencerStatus;
export const selectConversionsBySubcategoryStatus = (state) => state.conversion.getConversionsBySubcategoryStatus;
export const selectConversionsBySocialMediaStatus = (state) => state.conversion.getConversionsBySocialMediaStatus;

export const selectConversionErrorsStats = (state) => state.conversion.errors?.rate;

export default conversionSlice.reducer;
